<template>
  <div>
    <Breadcrumbs :items="items" />
    <v-sheet class="transparent-background-color pa-4">
      <div>
        <v-card>
          <v-card-title class="mx-3">
            {{ $t("Wave.StockSortingFields.title") }}
            <v-spacer></v-spacer>
            <v-sheet class="pt-1 transparent-background-color d-inline-block">
              <v-btn
                v-if="
                  $permission.permissionAllow('Waves', 'forceCompleteSorting')
                "
                small
                dark
                color="danger"
                class="px-2 me-2 mb-1"
                @click.stop="forceCompleteSorting()"
              >
                <v-icon x-small class="pe-1">fa-check-double</v-icon>
                {{ $t("Wave.actions.forceCompleteSorting") }}
              </v-btn>
              <v-btn
                v-if="$permission.permissionAllow('Waves', 'submitSorting')"
                small
                dark
                color="action"
                class="px-2 me-2 mb-1"
                @click.stop="submit()"
              >
                <v-icon x-small class="pe-1">fa-check</v-icon>
                {{ $t("Wave.actions.pickingFinish") }}
              </v-btn>
            </v-sheet>
          </v-card-title>

          <v-progress-linear :indeterminate="loading"></v-progress-linear>
          <v-card-text>
            <v-container>
              <v-row align="center">
                <v-col class="font-weight-black">
                  <v-text-field
                    ref="material_bar_code"
                    v-model="materialBarCode"
                    single-line
                    autofocus
                    dense
                    :label="
                      $t('Material.title') + $t('Material.Fields.barcode')
                    "
                  >
                  </v-text-field>
                </v-col>
              </v-row>
              <!-- 当前分拣信息展示 -->
              <v-row align="center" class="mt-5" style="height: 320px">
                <v-col cols="6" class="font-weight-bold text-center">
                  <div v-if="Object.keys(material_sorting).length">
                    <h1>
                      {{
                        $t("Material.Fields.material_name") + $t("Global.colon")
                      }}
                      <span class="danger--text">{{
                        material_sorting.material_name
                      }}</span>
                    </h1>
                    <br />
                    <h1>
                      {{ $t("Material.Fields.barcode") + $t("Global.colon") }}
                      <span class="danger--text">{{
                        material_sorting.barcode
                      }}</span>
                    </h1>
                  </div>
                </v-col>
                <v-col cols="6" class="font-weight-black text-center">
                  <div
                    class="transition-swing danger--text"
                    style="font-size: 300px"
                  >
                    {{ sorting_location }}
                  </div>
                </v-col>
              </v-row>
              <!-- 分拣位置 -->
              <v-row align="center" style="margin-top: 100px">
                <v-col cols="4" class="font-weight-bold text-center">
                  <v-item-group>
                    <h2 style="display: inline-block">
                      {{
                        $t("Wave.StockSortingFields.wait_sorting") +
                        $t("Global.colon")
                      }}
                    </h2>
                    <v-item
                      v-for="detail in sortingDetails"
                      :key="detail.location_num"
                    >
                      <v-btn
                        text
                        :style="
                          detail.sort_status == 1
                            ? 'font-size: 28px;'
                            : 'display:none;'
                        "
                        color="action"
                        @click.stop="
                          materialsInfoDialog = true;
                          sortingLocationDetail = JSON.parse(
                            JSON.stringify(detail)
                          );
                        "
                      >
                        {{ detail.sort_status == 1 ? detail.location_num : "" }}
                      </v-btn>
                    </v-item>
                  </v-item-group>
                </v-col>
                <v-col cols="4" class="font-weight-bold text-center">
                  <v-item-group>
                    <h2 style="display: inline-block">
                      {{
                        $t("Wave.StockSortingFields.sorting") +
                        $t("Global.colon")
                      }}
                    </h2>
                    <v-item
                      v-for="detail in sortingDetails"
                      :key="detail.location_num"
                    >
                      <v-btn
                        text
                        :style="
                          detail.sort_status == 2
                            ? 'font-size: 28px;'
                            : 'display:none;'
                        "
                        color="action"
                        @click.stop="
                          materialsInfoDialog = true;
                          sortingLocationDetail = JSON.parse(
                            JSON.stringify(detail)
                          );
                        "
                      >
                        {{ detail.sort_status == 2 ? detail.location_num : "" }}
                      </v-btn>
                    </v-item>
                  </v-item-group>
                </v-col>
                <v-col cols="4" class="font-weight-bold text-center">
                  <v-item-group>
                    <h2 style="display: inline-block">
                      {{
                        $t("Wave.StockSortingFields.finished_sorting") +
                        $t("Global.colon")
                      }}
                    </h2>
                    <v-item
                      v-for="detail in sortingDetails"
                      :key="detail.location_num"
                    >
                      <v-btn
                        text
                        :style="
                          detail.sort_status == 3
                            ? 'font-size: 28px;'
                            : 'display:none;'
                        "
                        color="action"
                        @click.stop="
                          materialsInfoDialog = true;
                          sortingLocationDetail = JSON.parse(
                            JSON.stringify(detail)
                          );
                        "
                      >
                        {{ detail.sort_status == 3 ? detail.location_num : "" }}
                      </v-btn>
                    </v-item>
                  </v-item-group>
                </v-col>
              </v-row>
            </v-container>
          </v-card-text>
        </v-card>
      </div>
    </v-sheet>
    <DialogAlert
      v-model="dialogAlert"
      :label="$t('MaterialCategory.ObjectName')"
      :message="dialogAlertMsg"
    />
    <MaterialsInfoDialog
      v-model="materialsInfoDialog"
      :sortingLocationDetail="sortingLocationDetail"
      v-on:sortingLocationDetail="
        sortingLocationDetail = JSON.parse(JSON.stringify($event))
      "
      :sorting-details="sortingDetails"
      v-on:sortingDetails="sortingDetails = JSON.parse(JSON.stringify($event))"
    />
  </div>
</template>
<script>
import i18n from "@/i18n";
import Breadcrumbs from "@/components/Breadcrumbs";
import { mapState } from "vuex";
import Waves from "@/api/waves";
import DialogAlert from "@/components/plugins/DialogAlert";
import MaterialsInfoDialog from "./plugins/MaterialsInfoDialog";

export default {
  components: {
    Breadcrumbs,
    DialogAlert,
    MaterialsInfoDialog,
  },
  computed: {
    items() {
      var items = [
        {
          text: i18n.t("Nav.home"),
          disabled: false,
          replace: true,
          href: "/home",
        },
        {
          text: i18n.t("Nav.stockManagement"),
          disabled: false,
          replace: true,
          href: "/stocks",
        },
        {
          text: i18n.t("Nav.waves"),
          disabled: false,
          href: "/waves",
        },
        {
          text: i18n.t("Nav.stockOrderBinding"),
          disabled: false,
          href:
            "/waves/stock-order-binding/" +
            this.$route.params.id +
            "?stock_id=" +
            this.$route.query.stock_id,
        },
        {
          text: i18n.t("Wave.StockSortingFields.title"),
          disabled: true,
        },
        {
          text: this.wave && this.wave.wave_code ? this.wave.wave_code : "",
          disabled: false,
          accent: true,
        },
      ];
      return items;
    },

    // 使用对象展开运算符将此对象混入到外部对象中
    ...mapState(["loading"]),
  },

  data: () => ({
    sortingDetails: [],
    sortingLocationDetail: {},
    materialBarCode: null,
    monitorTime: "",
    dialogAlert: false,
    dialogAlertMsg: "",
    materialsInfoDialog: false,
    material_sorting: {},
    lock_materials: {},
    sorting_location: 0,
    wave: null,
  }),

  mounted() {
    this.getWaitSortingMaterials();
    //获取波次信息
    Waves.fetchOne(this.$route.params.id).then(
      function (response) {
        if (response.data.status.isOK()) {
          this.wave = response.data.wave;
        }
      }.bind(this)
    );
  },

  methods: {
    getWaitSortingMaterials() {
      Waves.getWaitSortingDetail({
        stock_id: this.$route.query.stock_id,
        wave_id: this.$route.params.id,
      }).then(
        function (response) {
          if (response.data.status.isOK()) {
            var sortingDetails = response.data.details;

            for (var key in sortingDetails) {
              var unsorting_materials = [];
              var sortedNum = 0; //分拣完成的商品个数
              Object.values(sortingDetails[key].material).forEach(
                function (material) {
                  material.lockable = false;
                  if (material.unSorting_num) {
                    if (material.unSorting_num <= material.confirm_num) {
                      material.sorting_num =
                        material.confirm_num - material.unSorting_num;
                      unsorting_materials.push(material);
                    } else {
                      material.sorting_num = 0;
                    }
                    material.sorting_all = false;
                  } else {
                    material.sorting_num = material.confirm_num;
                    material.sorting_all = true;
                    ++sortedNum;
                  }
                }.bind(this)
              );

              if (!unsorting_materials.length) {
                Object.assign(sortingDetails[key], {
                  sort_status: 3, //已完成
                });
              } else if (
                unsorting_materials.length <
                Object.keys(sortingDetails[key].material).length
              ) {
                Object.assign(sortingDetails[key], {
                  sort_status: 2, //分拣中
                });
              } else {
                Object.assign(sortingDetails[key], {
                  sort_status: 1, //待分拣
                });
              }

              Object.assign(sortingDetails[key], {
                location_num: key,
                sorted_num: sortedNum,
              });
            }
            this.sortingDetails = Object.values(sortingDetails);
          }
        }.bind(this)
      );
    },
    //锁定商品
    lockMaterial(materialDetail) {
      Waves.lockMaterialSorting({
        stock_id: this.$route.query.stock_id,
        wave_id: this.$route.params.id,
        material_id: materialDetail.material_id,
      }).then(
        function (response) {
          if (response.data.status.isOK()) {
            materialDetail.lockable = true; //锁定商品
            for (var key in this.sortingDetails) {
              if (
                Object.keys(this.lock_materials).indexOf(
                  this.sortingDetails[key].stock_order_code
                ) == -1
              ) {
                Object.values(this.sortingDetails[key].material).some(
                  function (material) {
                    if (material.barcode == this.materialBarCode) {
                      material.lockable = true;
                    }
                  }.bind(this)
                );
              }
            }
            this.updateSortingDetails();
          } else {
            this.materialBarCode = null;
          }
        }.bind(this)
      );
    },
    //bar_code输入框修改分拣详情
    updateSortingDetails() {
      var sortingError = true;
      var nofound = true;
      this.sortingDetails.some(
        function (sorting_detail) {
          var findNum = 0;
          Object.values(sorting_detail.material).some(
            function (material) {
              //商品是否可拣
              if (material.barcode == this.materialBarCode) {
                nofound = false;
                if (material.sorting_num < material.confirm_num) {
                  ++findNum;
                  sortingError = false;
                  ++material.sorting_num;
                  if (material.sorting_num == material.confirm_num) {
                    ++sorting_detail.sorted_num;
                    material.sorting_all = true;
                  }
                  this.material_sorting = material;
                  this.sorting_location = sorting_detail.location_num;
                }
              }
            }.bind(this)
          );

          if (!findNum) {
            //当前出库单未查询到相应商品进入下个出库单查询
            return false;
          } else {
            if (
              !sortingError &&
              sorting_detail.sorted_num <
                Object.values(sorting_detail.material).length
            ) {
              sorting_detail.sort_status == 2
                ? ""
                : (sorting_detail.sort_status = 2); //分拣中
              return true;
            }
            if (
              sorting_detail.sorted_num ==
              Object.values(sorting_detail.material).length
            ) {
              sorting_detail.sort_status = 3; //已完成
              return true;
            }
          }
        }.bind(this)
      );
      //清空条码input框
      this.materialBarCode = null;
      //判断商品是否存在
      if (nofound) {
        this.dialogAlertMsg = i18n.t("Wave.Messages.no_material_found");
        this.dialogAlert = true;
      }
      //判断商品是否拣超
      if (sortingError && !nofound) {
        this.dialogAlertMsg = i18n.t("Wave.Messages.greater_than_sorting_num");
        this.dialogAlert = true;
      }
    },
    //提交分拣
    submit() {
      var stock_order = [];
      this.sortingDetails.forEach(
        function (sorting_detail) {
          for (var key in sorting_detail.material) {
            var default_num = 0;
            if (
              sorting_detail.material[key].lockable &&
              sorting_detail.material[key].sorting_num
            ) {
              if (
                sorting_detail.material[key].sorting_num ==
                sorting_detail.material[key].confirm_num
              ) {
                if (
                  sorting_detail.material[key].unSorting_num ==
                  sorting_detail.material[key].confirm_num
                ) {
                  default_num = sorting_detail.material[key].sorting_num;
                } else if (
                  sorting_detail.material[key].unSorting_num <
                  sorting_detail.material[key].confirm_num
                ) {
                  default_num = sorting_detail.material[key].unSorting_num;
                }
              } else if (
                sorting_detail.material[key].sorting_num <
                sorting_detail.material[key].confirm_num
              ) {
                if (
                  sorting_detail.material[key].unSorting_num ==
                  sorting_detail.material[key].confirm_num
                ) {
                  default_num = sorting_detail.material[key].sorting_num;
                } else if (
                  sorting_detail.material[key].unSorting_num <
                    sorting_detail.material[key].confirm_num &&
                  sorting_detail.material[key].sorting_num >
                    sorting_detail.material[key].unSorting_num
                ) {
                  default_num =
                    sorting_detail.material[key].sorting_num -
                    sorting_detail.material[key].unSorting_num;
                }
              }
              stock_order.push({
                material_id: sorting_detail.material[key].material_id,
                default_num: default_num,
                stock_order_code: sorting_detail.stock_order_code,
              });
            }
          }
        }.bind(this)
      );
      Waves.submitWaveSorting({
        stock_id: this.$route.query.stock_id,
        wave_id: this.$route.params.id,
        stock_order: stock_order,
      }).then(
        function (response) {
          if (response.data.status.isOK()) {
            this.$router.replace("/waves");
          }
        }.bind(this)
      );
    },
    //强制完成
    forceCompleteSorting() {
      Waves.forceCompleteSorting({ wave_id: this.$route.params.id }).then(
        function (response) {
          if (response.data.status.isOK()) {
            this.$router.replace("/waves");
          }
        }.bind(this)
      );
    },
  },

  watch: {
    materialBarCode: {
      handler() {
        clearInterval(this.monitorTime);
        if (this.materialBarCode) {
          this.monitorTime = setTimeout(
            function () {
              var sortingDetail = this.sortingDetails.find((detail) =>
                Object.values(detail.material).find(
                  (material_detail) =>
                    material_detail.barcode == this.materialBarCode
                )
              );
              if (sortingDetail) {
                var materialDetail = Object.values(sortingDetail.material).find(
                  (material_detail) =>
                    material_detail.barcode == this.materialBarCode
                );
                if (materialDetail && !materialDetail.lockable) {
                  this.lock_materials[sortingDetail.stock_order_code] =
                    materialDetail;
                  this.lockMaterial(materialDetail);
                } else {
                  this.updateSortingDetails();
                }
              } else {
                this.dialogAlertMsg = i18n.t("Wave.Messages.no_material_found");
                this.dialogAlert = true;
                this.materialBarCode = null;
              }
            }.bind(this),
            400
          );
        }
      },
    },

    sortingLocationDetail: {
      handler() {
        if (!this.materialsInfoDialog) {
          for (var key in this.sortingLocationDetail.material) {
            if (
              this.sortingLocationDetail.material[key].sorting_num >
              this.sortingLocationDetail.material[key].confirm_num -
                this.sortingLocationDetail.material[key].unSorting_num
            ) {
              //分拣信息显示
              this.sorting_location = this.sortingLocationDetail.location_num;
              this.material_sorting = this.sortingLocationDetail.material[key];
            }
          }

          //更新分拣详情
          this.sortingDetails.forEach((sorting_detail, key) => {
            if (
              sorting_detail.stock_order_code ==
              this.sortingLocationDetail.stock_order_code
            ) {
              this.sortingDetails[key] = JSON.parse(
                JSON.stringify(this.sortingLocationDetail)
              );
            }
          });
        }
      },
    },

    dialogAlert: {
      handler() {
        if (!this.dialogAlert) {
          this.$nextTick(() => {
            this.$refs.material_bar_code.focus();
          });
        }
      },
    },
  },

  beforeDestroy() {
    clearInterval(this.monitorTime);
  },
};
</script>